import React, { Fragment, useEffect, useState, useContext } from 'react';
import styles from './EchoMagazine.module.scss';
import PageTopHeader from '../../Molecules/TableTopHeader/PageTopHeader';
import Box from '../../Molecules/majorBox/Box';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../Molecules/Academic_E_G/DeleteModal';
import DetailsModal from '../../Molecules/Academic_E_G/ViewModal';
import AddEditPage from './AddEditPage';
import { useFetchEchoMagazine } from '../../../Hooks/Academic';
import { useDeleteEchoMagazine } from '../../../Hooks/Academic';
import { toast } from 'react-toastify';
import ActivityHeader from '../../Molecules/Academic_E_G/ActivityHeader';
import TablePagination from '../../Molecules/Pagination/TablePagination';
import {
  DetailsContext,
  PageTitleContext,
} from '../../HOC/GeneralBody/GeneralBody';
import { useToast } from '../../Molecules/Custom/CustomToaster/Toast';
import NoDataComponent from '../../Molecules/Custom/NoDataComponent/NoDataComponent';
import Loader from '../../Molecules/Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const ProgramsPage = ({ type }) => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState();
  const [selectedActivity, setSelectedActivity] = useState(null);
  const customizedToast = useToast();
  const HeaderAttr = useContext(PageTitleContext);
  const EditAdd = useContext(DetailsContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [showDetails, setShowDetails] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedEchoMagazine, setSelectedEchoMagazine] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [moveRight, setMoveRight] = useState(false);

  const { mutate: deleteEchoMagazine, isLoading: isAddingUser } =
    useDeleteEchoMagazine();

  const {
    data: echoMagazine,
    refetch: refetchEchoMagazine,
    isLoading: isLoadingEchoMagazine,
  } = useFetchEchoMagazine({
    pageSize: PageSize,
    pageNumber: Page,
    selectedActivity: selectedActivity,
    search: search,
    type: type,
  });
  const itemsPerPage = echoMagazine?.data?.pageSize;
  const totalItems = echoMagazine?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const data = echoMagazine?.data?.items.filter((i) =>
    i.title_AR?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleDelete = (id) => {
    deleteEchoMagazine(id, {
      onSuccess: () => {
        refetchEchoMagazine();
        setDeleteMode(false);
        setShowDetails(false);
        customizedToast.open('تم الحذف بنجاح');
      },
      onError: (error, data) => {
        toast.error('An error occurred');
      },
    });
  };
  //------------------------------------------------------------------------------

  useEffect(() => {
    refetchEchoMagazine();
  }, [Page, PageSize, selectedActivity, search]);

  useEffect(() => {
    if (!EditAdd.details) {
      refetchEchoMagazine();
      HeaderAttr.setMoveRight('2px');
    } else {
      HeaderAttr.setMoveRight('40px');
    }
  }, [EditAdd.details]);

  useEffect(() => {
    refetchEchoMagazine();
    setSelectedActivity(null);
    EditAdd.setDetails(null);
  }, [type]);

  return (
    <Fragment>
      {EditAdd.details ? (
        <AddEditPage
          setAddEditMode={EditAdd.setDetails}
          selectedEchoMagazine={selectedEchoMagazine}
          type={type}
          addEditMode={EditAdd.details}
          setMoveRight={setMoveRight}
          moveRight={moveRight}
        />
      ) : (
        <div className={styles['container']}>
          <div
            className={styles['table-container']}
            style={{ padding: '10px 0px 10px 0px' }}
          >
            <PageTopHeader
              search={searchQuery}
              setSearch={setSearchQuery}
              handleOnAdd={(e) => {
                EditAdd.setDetails('show');
                setSelectedEchoMagazine(null);
                setShowDetails(false);
              }}
              type={type}
              padding="10px"
            />
          </div>

          <ActivityHeader
            selectedActivity={selectedActivity}
            setSelectedActivity={setSelectedActivity}
          />

          <div className={styles['table-container']}>
            {isLoadingEchoMagazine ? (
              <Loader />
            ) : (
              <>
                {data?.length > 0 ? (
                  <div
                    className={`${styles['major-box-grid']} ${
                      data?.length < 3 ? styles['smaller-grid'] : ''
                    }`}
                  >
                    {' '}
                    {data &&
                      data?.map((item) => (
                        <Box
                          key={item.magazineId}
                          id={item.magazineId}
                          image={sanitizeAndValidateUrl(
                            item.url + item.magazineThumbnail
                          )}
                          title={item.title_AR}
                          date={item.magazineDate}
                          years={item.magazineDate}
                          active={item.isActive}
                          setDeleteMode={setDeleteMode}
                          setAddEditMode={EditAdd.setDetails}
                          setSelectedItem={setSelectedItem}
                          setShowDetails={setShowDetails}
                          echoMagazine={data}
                          refetchEchoMagazine={refetchEchoMagazine}
                          setSelectedEchoMagazine={setSelectedEchoMagazine}
                          item={item}
                          onClick={() => {
                            setShowDetails(true);
                            setSelectedEchoMagazine(item);
                            setSelectedItem(item.magazineId);
                          }}
                        />
                      ))}
                  </div>
                ) : (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {' '}
                    <NoDataComponent />
                  </div>
                )}

                <TablePagination
                  totalPages={totalPages}
                  page={Page}
                  setPage={setPage}
                  itemsPerPage={PageSize}
                  setPageSize={setPageSize}
                />
              </>
            )}
          </div>

          {deleteMode && (
            <DeleteModal
              title="المجلة"
              handleOnClose={() => setDeleteMode(false)}
              handleDelete={handleDelete}
              selectedItem={selectedItem}
            />
          )}
          {showDetails && (
            <DetailsModal
              selectedDetails={selectedEchoMagazine}
              handleOnClose={() => setShowDetails(false)}
              handleEdit={() => (
                EditAdd.setDetails('show'), setShowDetails(false)
              )}
              handleDelete={handleDelete}
              selectedItem={selectedItem}
              setDeleteMode={setDeleteMode}
            />
          )}
        </div>
      )}
    </Fragment>
  );
};

export default ProgramsPage;
